import { FC, useEffect, useRef } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import LottiFile from '@assets/json/Astronaut-with-space-shuttle.json';
import styles from './index.module.scss';

interface ILoading {
  text?: string;
}
const Loading: FC<ILoading> = ({
  text = 'Please wait, your story is being crafted and will be available soon.',
}) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  useEffect(() => {
    if (lottieRef.current) {
      lottieRef.current.setSpeed(2);
    }
  }, [lottieRef.current]);

  return (
    <div className={styles['loading']}>
      <div className={styles['animation']}>
        <Lottie lottieRef={lottieRef} animationData={LottiFile} loop autoplay />
      </div>

      <h2 className={styles['title']}>{text}</h2>
    </div>
  );
};

export default Loading;
